import { Injectable } from '@angular/core';
import { FirebaseData } from '../providers/firebase-data';
import { FirebaseStorage } from '../providers/firebase-storage';
import { Observable } from 'rxjs/Observable';
import { Utils } from '../providers/utils';
import firebase from 'firebase';

@Injectable()
export class DonationData {
    public realtimeDb: any;

    constructor(private firebaseData: FirebaseData, private firebaseStorage: FirebaseStorage) {
    	this.realtimeDb = firebase.database();
    }

    public getAllDonationByUser(uid, numofRecords){
    	var self = this;
        return Observable.create((observer) =>{
            self.realtimeDb.ref('user-donations/'+uid).limitToLast(numofRecords).once('value', data => {
                let donations = [];
                if(data){
                    donations = Utils.toArray(data.val());
                    donations = donations.reverse();
                }
                observer.next(donations);
            });
        });
    }
    
    public addDonation(uid, formData){
    	return Observable.create((observer) =>{
            // Get a key for a new Donation.
            var newKey = firebase.database().ref().child('donations').push().key;
            var updates = {};
            
            // Get timestamp

            var timeStamp = (<any>firebase.database).ServerValue.TIMESTAMP;
            formData.timestampCreated = timeStamp;
            
            // Just upload posts
            updates['/donations/' + newKey]                       = formData;
            updates['/user-donations/' + uid + '/' + newKey]      = formData;
        
            this.realtimeDb.ref().update(updates).then(function(){
                observer.next({'donation': {key: newKey, value: formData}});
            }, function(error){
                observer.next(false);
            });
            
    	});
    }
   
    public deleteDonation(uid, donationId){
    	return Observable.create((observer) => {
    		var updates = {};
            updates['/donations/' + donationId]                      = null;
            updates['/user-donations/' + uid + '/' + donationId]     = null;

            this.realtimeDb.ref().update(updates).then(function(){
                observer.next(true);
            }, function(error){
                observer.next(false);
            });
    	})
    }    
}


// WEBPACK FOOTER //
// ./src/providers/donation-data.ts